import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Calendar } from 'lucide-react';
import { Footer } from '../components/Footer';

export function LoginPage() {
    const { isAuthenticated, isLoading, login } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated, navigate]);

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
            }}>
                <div className="spinner" />
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            background: 'linear-gradient(135deg, #0A2F5E 0%, #1A3A52 100%)',
        }}>
            <div style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <div className="card" style={{
                    maxWidth: '400px',
                    width: '100%',
                    textAlign: 'center',
                    padding: 'var(--space-8)'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 'var(--space-5)',
                        color: 'var(--color-primary)'
                    }}>
                        <Calendar size={48} />
                    </div>

                    <h1 style={{ marginBottom: 'var(--space-2)' }}>
                        AAM <span style={{ color: 'var(--color-primary)' }}>Let's Meet</span>
                    </h1>

                    <p style={{
                        color: 'var(--color-gray-500)',
                        marginBottom: 'var(--space-6)'
                    }}>
                        Schedule meetings with ease. Propose times, collect responses, find the perfect slot.
                    </p>

                    <button
                        onClick={login}
                        className="btn btn-primary btn-lg"
                        style={{ width: '100%' }}
                    >
                        Sign in with Insight
                    </button>

                    <p style={{
                        marginTop: 'var(--space-5)',
                        fontSize: 'var(--font-size-sm)',
                        color: 'var(--color-gray-500)'
                    }}>
                        Use your AAM Group credentials to sign in
                    </p>
                </div>
            </div>
            
            <Footer />
        </div>
    );
}
